'use client'

import { SWRConfig } from 'swr'
import { ConfirmProvider, Toaster } from '@streep/ui'
import { isSessionExpired } from '@/lib/session-expired'
import { SessionExpiredNotice } from './app-shell/session-expired-notice'

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <SWRConfig
      value={{
        revalidateOnFocus: false,
        dedupingInterval: 5_000,
        // FO-374 C - zodra de sessie verlopen is, pauzeert SWR alle revalidatie
        // (badge-polls incl.) globaal, zodat een open tab niet elke minuut blijft
        // 401/403'en. De herlogin-flow (SessionExpiredNotice) neemt het over.
        isPaused: isSessionExpired,
      }}
    >
      <ConfirmProvider>
        {children}
        <SessionExpiredNotice />
        <Toaster />
      </ConfirmProvider>
    </SWRConfig>
  )
}
